<template>

  <!-- search-top -->
  <div class="search-top">
    <div class="row">
      <div class="col-md-6 col-lg-4">
        <div class="search-box">
          <form>
            <div class="form-group">
              <input type="search" class="form-control" placeholder="Search" aria-label="search">
              <img class="img-fluid sea-icon" src="@/assets/img/search.svg" alt="image title">
            </div>
          </form>
        </div>
      </div>
      <div class="col-md-6 col-lg-8">
        <div class="export-right">
          <div class="export">
            <a href="#"> <img class="img-fluid" src="@/assets/img/export.svg" alt="image title"> Export</a>
          </div>
          <div class="todayselect">
            <div class="reportrange">
              This Month <i class="fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- search-top -->


  <!-- review-table -->
  <div class="review-table">
    <table class="display" id="dataTable">
      <thead>
      <tr>
        <th>Name</th>
        <th>Phone/Email</th>
        <th>Sent by</th>
        <th>Sent Time</th>
        <th>Followed Link</th>
        <th>Review</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      <tr>
        <td>
          <a class="manname" href="#"><img class="img-fluid" src="@/assets/img/man.png" alt="image title"> Shane
            Hawkins </a>
        </td>
        <td>+180 545 0333</td>
        <td>Ahmad Sobhan</td>
        <td>Mar 16, 2021 <br> 01:32 pm</td>
        <td><img class="img-fluid" src="@/assets/img/Line.svg" alt="image title"></td>
        <td><img class="img-fluid" src="@/assets/img/check.svg" alt="image title"></td>
      </tr>

      </tbody>
    </table>
  </div>
  <!-- review-table -->

</template>
<script>
import $ from "jquery";

import {onMounted} from "vue";

export default {
  components: {},
  setup() {
    let base_url = "http://api.streamly.com/uploads/";
    // Open Modal
    const openModal = () => {
      $("#featureNotAvailable").modal("show");
    };

    // Close Modal
    const closeModal = () => {
      $("#featureNotAvailable").modal("hide");
    };
    const datatableInit = async () => {
      if ($.fn.DataTable.isDataTable("#dataTable")) {
        $("#dataTable").DataTable().clear().destroy();
      }
      $("#dataTable").addClass("nowrap").dataTable({
        order: [],
        columnDefs: [
          {targets: [1], orderable: false}
        ]
      });
    }
    onMounted(() => {
      datatableInit();
      window.showHideMainLoader(false);
    });

    return {openModal, closeModal, base_url};
  },
};
</script>